import {
  ArtifactAudit,
  ArtifactAuditReviewRequest,
} from '../types/blob-types';
import { blobsApiClient } from './blobService';

const artifactAuditApi = blobsApiClient.injectEndpoints({
  endpoints: (builder) => ({
    getArtifactAudit: builder.query<
      ArtifactAudit,
      { artifactId: string }
    >({
      query: ({ artifactId }) => `api/artifacts/${artifactId}/audit/`,
      providesTags: (result, error, { artifactId }) => [
        { type: 'ArtifactAudit', id: artifactId },
      ],
    }),
    rerunArtifactAudit: builder.mutation<
      ArtifactAudit,
      { artifactId: string; matterId: string }
    >({
      query: ({ artifactId }) => ({
        url: `api/artifacts/${artifactId}/audit/rerun/`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, { artifactId, matterId }) => [
        { type: 'ArtifactAudit', id: artifactId },
        { type: 'Blobs', id: matterId },
      ],
    }),
    submitArtifactAuditReview: builder.mutation<
      ArtifactAudit,
      {
        artifactId: string;
        matterId: string;
        blobId: string;
        body: ArtifactAuditReviewRequest;
      }
    >({
      query: ({ artifactId, body }) => ({
        url: `api/artifacts/${artifactId}/audit/review/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { artifactId, matterId, blobId }) => [
        { type: 'ArtifactAudit', id: artifactId },
        { type: 'Blobs', id: matterId },
        { type: 'BlobDetail', id: `${matterId}-${blobId}` },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetArtifactAuditQuery,
  useRerunArtifactAuditMutation,
  useSubmitArtifactAuditReviewMutation,
} = artifactAuditApi;
